import type { Countdown } from '@/hooks/use-countdown';

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

// Always 2 most-significant units, zero-padded — keeps the rendered
// width stable across ticks and unit rollovers (e.g. "1d 0h" → "23h 59m"
// stays 7 chars), so the row never reflows.
export function compactCountdown(cd: Countdown): string {
  if (cd.days >= 1) return `${pad(cd.days)}d ${pad(cd.hours)}h`;
  if (cd.hours >= 1) return `${pad(cd.hours)}h ${pad(cd.minutes)}m`;
  return `${pad(cd.minutes)}m ${pad(cd.seconds)}s`;
}
